var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{attrs:{"redirectWithLoginFailed":true},on:{"loggedIn":_vm.onLoggedIn}},[_c('Header',{attrs:{"content":_vm.headerContent}}),_c('div',{staticClass:"wrap-lisence-activation"},[_c('ModuleLicenseActivation')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }